define('ShareCart.Button.View', [
    'sharecart_button.tpl',
    'ShareCart.Modal.View',
    'Backbone'
], function ShareCartButtonView(
    shareCartButtonTpl,
    ShareCartModalView,
    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: shareCartButtonTpl,
        initialize: function initialize(options) {
            this.application = options.container;
            this.cart = options.cart;
        },
        events: {
            'click [data-action="open-share-cart-modal"]': 'openModal'
        },
        openModal: function openModal() {
            var view = new ShareCartModalView({
                application: this.application,
                cart: this.cart
            });
            view.showInModal();
        }
    });
});
